<template>
  <div class="form-identification-card">
    <div class="form-identification-card__row serial">
      <input-text
        type="text"
        placeholder="Номер"
        title="Номер"
        v-bind:violations="numberInputError"
        v-mask="'#########'"
        v-model="identification.number" />
      <input-date
        class="form-identification-card__date"
        label="Когда выдан"
        v-bind:violations="whenIssuedInputError"
        v-model="identification.whenIssued" />
    </div>
  </div>
</template>

<script>
import { Identification } from '@/storage/gateways/PatientGateway';
import InputText from '@/components/InputText.vue';
import InputDate from '@/components/InputDate.vue';

/**
 * События обновления модели
 * @type {string}
 */
const ON_MODEL_UPDATE = 'on-model-update';

/**
 * @description Разрешить получение списка ошибок для поля ввода.
 * @param {string} cause Имя поля ввода.
 * @returns {function}
 */
const resolveInputErrors = (cause) => (vm) => (
  cause in vm.inputErrors ? vm.inputErrors[cause] : []
);
export default {
  components: {
    InputDate,
    InputText,
  },
  computed: {
    numberInputError: resolveInputErrors('identification.number'),
    whenIssuedInputError: resolveInputErrors('identification.when_issued'),
  },
  name: 'form-identification-card',
  props: {
    initIdentification: { required: true, type: Identification },
    inputErrors: { required: true, type: Object },
  },
  watch: {
    /**
     * @description Данные обновились
     *
     * @param newValue
     * @param oldValue
     */
    identification: {
      handler(newValue) {
        this.$emit(ON_MODEL_UPDATE, newValue);
      },
      deep: true,
    },
    /**
     * @description Данные родителя обновились
     *
     * @param newValue
     */
    initIdentification: {
      handler(newValue) {
        this.identification = newValue;
      },
      deep: true,
    },
  },
  created() {
    this.identification = this.initIdentification;
  },
  data() {
    return {
      /**
       * @description Удостоверение личности
       * @type {object}
       */
      identification: {},
    };
  },
};
</script>

<style scoped lang="scss">
.form-identification-card {
  display: grid;
  row-gap: 20px;
  &__row {
    display: grid;
    grid-template-columns: 333px 236px;
    grid-gap: 11px;
    &.serial {
      grid-template-columns: 150px 150px 1fr;
      max-width: 100%;
    }
  }
  &__copy {
    margin-top: 15px;
    &__button {
      display: flex;
      align-items: center;
      font-weight: 400;
      font-size: 12px;
      margin: 0 0 2px 0;
      color: var(--unfocus-color);
      &:after {
        content: '';
        background-image: url("@/assets/img/copy-blue.svg");
        background-repeat: no-repeat;
        background-position: bottom;
        background-size: contain;
        margin: 0 0 0 10px;
        width: 15px;
        height: 15px;
      }
    }
  }
  &__invalid {
    color: var(--warning-color);
    font-size: 12px;
    font-weight: 400;
    padding: 0.125rem;
    margin-bottom: 0;
  }
  &__snils {
    width: 333px;
  }
  &__belay {
    width: 100%;
  }
}

@media screen and (max-width: 970px) {
  .form-identification-card {
    &__belay,
    &__snils,
    &__date {
      width: 100%;
    }
    &__row {
      grid-template-columns: 1fr;
      grid-gap: 20px;
      &.serial {
        grid-template-columns: 1fr;
      }
    }
    &__representative {
      &__row {
        grid-template-columns: 1fr;
      }
    }
  }
}
@media screen and (max-width: 480px) {
  .form-identification-card {
    &__medical {
      &-card {
        padding: 20px 15px;
        &__info {
          flex-direction: column;
          align-items: flex-start;
        }
        &__buttons {
          width: 230px;
          flex-direction: column;
        }
        &__button {
          &-print {
            display: none;
          }
          &-save {
            max-width: 100%;
          }
        }
      }
    }
    &__representative {
      &__row {
        &.document {
          grid-template-columns: 1fr;
        }
      }
    }
  }
}
</style>
